export const enum BatchStatusEnum {
  InProgress = 1,
  Posted = 2,
  Reverted = 3
}

export enum TypeOfFileEnum {
  original = 0,
  replacement = 1
}



// WEBPACK FOOTER //
// ./src/app/core/enums/batch-status.enum.ts